import { marketsConfig } from './config';
import { Language, Market } from './types';

export const getLanguagePrefixForMarket = (market: Market, lang: Language) => {
  const langPrefix = marketsConfig[market].languages
    .find((l) => l.code === lang)
    ?.langPrefix?.toLowerCase();

  return langPrefix ? `/${langPrefix}` : '';
};

// Note to our future self: path.join() is not ideal for dealing with http urls, so we implement some helper functions. We came to this point several times ;)
export const removeLeadingSlash = (url: string) =>
  url.startsWith('/') ? url.substring(1) : url;

export const ensureTrailingSlash = (url: string) =>
  !url.endsWith('/') ? `${url}/` : url;
